import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { Router } from '@angular/router';
import { PropertyStatus } from '../../shared/enum/enum';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { IBrokerageList } from '../../shared/models/BrokerageListOutputModel';
import { DocumentOutputModel, IDataEntryStaffPropertyOutputList } from '../../shared/models/DataEntryStaffPropertyListOutputModel';
import { BrokerageManagerService } from '../../shared/providers/brokerage-manager.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../shared/providers/toast.service';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { ILookUp } from '../../shared/models/LookUpOutputModel';
import { CommonService } from '../../shared/providers/common.service';
import { IPropertyCard, PropertyIdList } from '../../shared/models/propertycard';
import { RestService } from '../../shared/providers/rest.service';
import { IUpdateTimestampModel } from '../../shared/models/IUpdateTimestampModel';

export enum Actions {
  NothingSelected = 0,
  ChangeStatus = 1,
  MarkAsComp = 2,
  MarkAsArchive = 3,
  AssignBroker = 4,
  Delete = 5,
  MoveToLiveListing = 6,
  Verify = 7
}
export enum CompOrArhive {
  Comp = 1,
  Archive = 2,
  LiveListing = 6,
  Verify = 7
}

@Component({
  selector: 'app-property-list',
  templateUrl: './property-list.component.html'
})
export class PropertyListComponent implements OnInit {

  constructor(private propertyService: PropertyListingService, private _toastService: ToastService,
    private modalService: BsModalService, private _brokerageManagerService: BrokerageManagerService,
    public Validation: ValidationService, private router: Router, public authService: AuthenticationService,
    private http: HttpClient, private _userManagerService: UserManagerService, protected _propertyListingService: PropertyListingService,
    protected loaderService: LoaderService, private Common: CommonService, private rest: RestService) { }
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  table: DataTableDirective;
  dtOptions = {};
  user: any;
  available: number = 0;
  rejected: number = 0;
  pending: number = 0;
  draft: number = 0;
  fromPage: string = this.router.url;
  viewSoldDetailsLink = false;
  isDataEntryProperty: boolean = true;
  propertyList: IDataEntryStaffPropertyOutputList[];
  selectedRows: IDataEntryStaffPropertyOutputList[] = [];
  propertyCompleteList = [];
  propertyStatus = PropertyStatus;
  propertyStatusId: number = 0;
  brokerageList: IBrokerageList[];
  brokerageId: number = 0;
  totalCount: number = 0;
  totalCountBrokerage: number = 0;
  isviewAll: boolean = true;
  isAvailable: boolean = false;
  isPending: boolean = false;
  isRejected: boolean = false;
  isDraft: boolean = false;
  selectedPropertyId: string;
  searchText: string = "";
  quickEditDetails = [];
  protected readonly BASE_URL: string = environment.base_url;
  selectedAction = 0;
  propertyIdList: PropertyIdList[];
  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  updateTimestamp = {} as IUpdateTimestampModel;
  VerifyProperty(propertyId: number, type, item) {
    this.updateTimestamp.PropertyId = propertyId;
    this.updateTimestamp.UserId = this.user.Id;
    if (type == 2) {
      this._brokerageManagerService.UpdatePropertyTimeStamp(this.updateTimestamp).subscribe(resp => {
        this.dtElement.dtInstance.then(x => x.draw(false));
        this._toastService.addToast({
          title: 'Success',
          msg: item.IsPortfolio ? "Portfolio verified" : 'Property verified',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
      });
    }
    else {
      this._brokerageManagerService.UpdateDataEntryPropertyTimeStamp(propertyId).subscribe(resp => {
        this.dtElement.dtInstance.then(x => x.draw(false));
        this._toastService.addToast({
          title: 'Success',
          msg: item.IsPortfolio ? "Portfolio verified" : 'Property verified',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
      });
    }


  }
  bindStatusCount(loggedinUserId) {

    //if (this.brokerageId == undefined) {
    //    this.brokerageId = null;
    //}
    //this._userManagerService.getPropertiesCountByBrokerage(loggedinUserId, this.brokerageId).subscribe(resp => {
    //    this.totalCountBrokerage = resp.toString();
    //})
    //this._userManagerService.getPropertiesByStatus(this.propertyStatus.Available, loggedinUserId, this.brokerageId).subscribe(res => {
    //    this.available = res.toString();

    //});
    //this._userManagerService.getPropertiesByStatus(this.propertyStatus.PendingApproval, loggedinUserId, this.brokerageId).subscribe(res => {
    //    this.pending = res.toString();


    //});
    //this._userManagerService.getPropertiesByStatus(this.propertyStatus.Rejected, loggedinUserId, this.brokerageId).subscribe(res => {
    //    this.rejected = res.toString();

    //});

  }


  viewAll = '';
  propertyStatusList: ILookUp[];
  IsPropLoading = false;
  ngOnInit() {
    this.Common.getPropertyStatus().subscribe(response => {
      let propertyStatus = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });

      if (this.authService.DataEntryStaff()) {
        this.propertyStatusList = propertyStatus.filter(x => x.id !== 354 && x.id !== 349 && x.id !== 350);
      }
      else {
        this.propertyStatusList = propertyStatus.filter(x => x.id !== 354);
      }
    });
    const that = this;
    this.user = this.authService.user;
    var loggedinUserId = this.user.Id;

    if (localStorage.getItem("brokerageId") != null) {
      var brokerageId = parseInt(localStorage.getItem("brokerageId"));
      this.brokerageId = brokerageId;
    }
    else {
      this.brokerageId = 0;
    }
    this.GetPropertyCount();
    if (localStorage.getItem("statusId") != null) {
      var statusId = parseInt(localStorage.getItem("statusId"));
      this.SelectByStatus(statusId);
      this.propertyStatusId = statusId;

    }
    if (localStorage.getItem("SearchText") != "null") {
      that.searchText = localStorage.getItem("SearchText");
    }
    else {
      that.searchText = null;
    }
    this.bindStatusCount(loggedinUserId);
    this._userManagerService.getBrokerages(loggedinUserId).subscribe(response => {
      this.brokerageList = response.map(o => { return { Id: o.Id, BrokerageName: o.BrokerageName }; });
    });
    this.reassignSelectedRows();
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      "pageLength": 50,
      stateSave: true,
      stateSaveCallback: function (settings, data) {
        localStorage.setItem("DataTables_property_dataEntryStaff_list_view", JSON.stringify(data));
      },
      stateLoadCallback: function (settings) {
        $(".dataTables_paginate.paging_full_numbers").show();
        return JSON.parse(localStorage.getItem("DataTables_property_dataEntryStaff_list_view"));
      },
      "order": [[12, "desc"]],
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsPropLoading = true;

        const filter =
        {
          StatusId: that.propertyStatusId,
          BrokerageId: that.brokerageId,
          PropertyTypeId: 6856
        }

        dataTablesParameters.Extra_param = filter;
        that.searchText = dataTablesParameters.search.value;
        const httpHeader = this.rest.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/property/dataEntryStaffPropertyList/' + loggedinUserId + '/0000',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            this.isDocumentLoaded = false;
            that.propertyList = resp.data ? resp.data : [];
            if (resp.data.length > 0) {
              this.GetDocumentList(that.propertyList);
              that.propertyList.forEach(item => {
                if (item.WebsiteURL != null) {
                  item.WebsiteURL = this.Validation.formatURL(item.WebsiteURL);
                }

                if (this.selectedRows.findIndex(x => x.Id == item.Id && x.Type == item.Type) > -1) {
                  item.IsSelected = true;
                }
                if (item.CharacteristicsId == 1) {
                  item.capRateText = 'ZCF';
                }
                else {
                  item.capRateText = String(item.CapRate);
                }
              });
              this.autoSelectAll();
              that.totalCount = resp.data.length;

            }
            if (resp.data.length === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
            $(".paginate_button.first,.paginate_button.last").hide();
            this.IsPropLoading = false;
          });
      },
      columns: [
        { data: 'Guid' },
        { data: 'Guid' },
        { data: 'Guid' },
        { data: 'PropertySequenceId' },
        { data: 'PropertyName' },
        { data: 'StateName' },
        { data: 'CityName' },
        { data: 'Price' },
        { data: 'PropertyStatus' },
        { data: 'CapRate' },
        { data: 'WebsiteURL' },
        { data: 'Updated' },
        { data: 'RecentActivity' },
        { data: 'TotalAttachmentCount' },
        { data: 'Comments' }]
    };
  }

  AuditId: number;
  modalRef: BsModalRef;

  documentList: DocumentOutputModel[];
  isDocumentLoaded: boolean = false;
  GetDocumentList(propertyList: IDataEntryStaffPropertyOutputList[]) {
    let propertyIdList = propertyList.map(o => { return { PropertyId: o.Id, TypeId: o.Type } });
    this.propertyService.GetDocumentsOfPropertiesOfDataEntryStaff(propertyIdList).subscribe(response => {
      this.isDocumentLoaded = false;
      if (response != null) {
        this.documentList = response;
        this.propertyList.forEach(item => {
          item.Documents = this.documentList.filter(x => x.ObjectId == item.Id);
          item.DDFileCount = item.Documents.filter(x => x.CategoryId != 401).length;
          item.OMFileCount = item.Documents.filter(x => x.CategoryId == 401).length;
        })

        this.isDocumentLoaded = true;
      }
    });
  }

  GetPropertyCount() {
    this.user = this.authService.user;
    var loggedinUserId = this.user.Id;

    this.propertyService.GetPropertiesOfDataEntryStaffCount(this.brokerageId, loggedinUserId).subscribe(response => {
      if (response != null) {
        this.available = response[0].AvailableCount;
        this.rejected = response[0].RejectedCount;
        this.pending = response[0].PendingCount;
        this.draft = response[0].DraftCount;
        this.totalCountBrokerage = response[0].TotalCount;
      }
    });
  }
  openModalForAuditTrailDetail(template: TemplateRef<any>, classes: any, id) {
    this.AuditId = id;;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  openModalForQuickEdit(template: TemplateRef<any>, classes: any, id, state, city, brokerage, type) {
    this.quickEditDetails = [];
    if (type == 2) {
      this.isDataEntryProperty = false;
    }
    else {
      this.isDataEntryProperty = true;
    }
    this.modalRef = this.modalService.show(template, { class: classes });
    this.selectedPropertyId = id;
    this.quickEditDetails.push(state, city, brokerage);
  }

  SelectByStatus(propertyStatusId) {
    if (propertyStatusId == this.propertyStatus.Available) {
      this.isAvailable = true;
      this.isPending = false;
      this.isRejected = false;
      this.isviewAll = false;
      this.isDraft = false;
    }
    if (propertyStatusId == this.propertyStatus.PendingApproval) {
      this.isPending = true;
      this.isRejected = false;
      this.isviewAll = false;
      this.isAvailable = false;
      this.isDraft = false;
    }
    if (propertyStatusId == this.propertyStatus.Rejected) {
      this.isRejected = true;
      this.isviewAll = false;
      this.isAvailable = false;
      this.isPending = false;
      this.isDraft = false;
    }
    if (propertyStatusId == this.propertyStatus.Draft) {
      this.isRejected = false;
      this.isviewAll = false;
      this.isAvailable = false;
      this.isPending = false;
      this.isDraft = true;
    }
    else if (propertyStatusId == 0) {
      this.isRejected = false;
      this.isviewAll = true;
      this.isAvailable = false;
      this.isPending = false;
      this.isDraft = false;
    }
  }
  filterByStatus(statusid, event) {
    this.propertyStatusId = statusid;
    this.SelectByStatus(this.propertyStatusId);
    localStorage.setItem("statusId", this.propertyStatusId.toString());
    localStorage.setItem("available", this.available.toString());
    localStorage.setItem("pending", this.pending.toString());
    localStorage.setItem("rejected", this.rejected.toString());
    localStorage.setItem("draft", this.rejected.toString());
    //this.resetSelectedRows();
    this.selectAll = false;
    this.onStatusSelect(event);
  }
  onStatusSelect($event) {

    if (this.propertyStatusId != undefined) {
      this.dtElement.dtInstance.then(x => x.draw());
      this.GetPropertyCount();
    }
  }
  closeModal($event) {
    this.modalRef.hide();
    this.dtElement.dtInstance.then(x => x.draw());
    this.GetPropertyCount();
  }
  reset() {
    this.propertyStatusId = 0;
    this.isRejected = false;
    this.isviewAll = true;
    this.isAvailable = false;
    this.isPending = false;
    this.isDraft = false;

    localStorage.setItem("SearchText", null);
    localStorage.setItem("statusId", this.propertyStatusId.toString());
    this.dtElement.dtInstance.then(x => x.draw());

  }

  onChangeBrokerage() {
    if (this.brokerageId != null) {
      localStorage.setItem("brokerageId", this.brokerageId.toString());
    }
    localStorage.removeItem("DataTables_property_dataEntryStaff_list_view");
    //this.resetSelectedRows();
    var loggedinUserId = this.user.Id;
    this.reset();
    this.bindStatusCount(loggedinUserId);
    this.available = 0;
    this.pending = 0;
    this.rejected = 0;
    this.draft = 0;
    this.searchText = null;
    this.totalCountBrokerage = 0;
    //localStorage.setItem("available", null);
    //localStorage.setItem("pending", null);
    //localStorage.setItem("rejected", null);
    //localStorage.setItem("totalCountBrokerage", null);
    this.GetPropertyCount();
    this.dtElement.dtInstance.then(x => x.draw());
  }

  downloadAllDoc(Documents, type, event: any) {
    if (type == 1) {
      for (let document of Documents.filter(x => x.CategoryId == 401)) {
        window.open(document.FilePath, '_blank');
      }
    }
    else {
      for (let document of Documents.filter(x => x.CategoryId != 401)) {
        window.open(document.FilePath, '_blank');
      }
    }

  }
  statusToChange = 0;
  showSelectStatus = false;
  ConfirmationHeading = '';
  confirmBody = '';
  compOrArhive = CompOrArhive.Comp;
  selectAll = false;
  onActionSelect(event, template: TemplateRef<any>, classes, CompOrArchive) {
    if (this.selectedRows.length == 0) {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least 1 property.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else {
      if (this.selectedAction == Actions.ChangeStatus) {
        this.statusToChange = 0;
        this.showSelectStatus = false;
        this.modalRef = this.modalService.show(template, { class: classes });
      }
      else if (this.selectedAction == Actions.MarkAsComp) {
        this.ConfirmationHeading = "Mark as comp";
        this.confirmBody = 'Are you sure to mark the selected ' + this.getSelectedCount() + ' properties as Comp ?'
        this.compOrArhive = CompOrArhive.Comp;
        this.modalRef = this.modalService.show(CompOrArchive, { class: 'deletemodal' });
      }
      else if (this.selectedAction == Actions.MarkAsArchive) {
        this.ConfirmationHeading = "Mark as Archive";
        this.confirmBody = 'Are you sure to mark the selected ' + this.getSelectedCount() + ' properties as Archive ?'
        this.compOrArhive = CompOrArhive.Archive;
        this.modalRef = this.modalService.show(CompOrArchive, { class: 'deletemodal' });
      }
      else if (this.selectedAction == Actions.MoveToLiveListing) {
        this.ConfirmationHeading = "Move to Live Listing";
        this.confirmBody = 'Are you sure to move the selected ' + this.getSelectedCount() + ' properties to live listing ?'
        this.compOrArhive = CompOrArhive.LiveListing;
        this.modalRef = this.modalService.show(CompOrArchive, { class: 'deletemodal' });
      }
      else if (this.selectedAction == Actions.Verify) {
        this.ConfirmationHeading = "Verify Listings";
        this.confirmBody = 'Are you sure to verify the selected ' + this.getSelectedCount() + ' properties ?'
        this.compOrArhive = CompOrArhive.Verify;
        this.modalRef = this.modalService.show(CompOrArchive, { class: 'deletemodal' });
      }
    }
    event.target.value = 0;
  }
  getSelectedCount() {
    //let count = 0;
    //this.propertyList.forEach(item => {
    //    if (item.IsSelected) {
    //        count++;
    //    }
    //});
    //return count;
    return this.selectedRows.length;
  }
  onCheckboxChange(event, Id, Type) {
    if (event.target.checked) {
      let prop = this.propertyList.find(x => x.Id == Id && x.Type == Type);
      this.selectedRows.push(prop);
    }
    else {
      this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == Id && x.Type == Type), 1);
    }
    this.preserveSelectedRows();
    this.autoSelectAll();
  }

  autoSelectAll() {
    if (this.propertyList.filter(x => x.IsSelected == true).length == this.propertyList.length && this.propertyList.length > 0) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
  }
  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.selectOrUnSelectAll(false);
    }
  }
  selectOrUnSelectAll(trueOrfalse) {
    this.propertyList.forEach(item => {
      item.IsSelected = trueOrfalse;
      if (trueOrfalse) {
        // if true then push all selected items into selectedRows collection
        if (this.selectedRows.findIndex(x => x.Id == item.Id && x.Type == item.Type) < 0) {
          this.selectedRows.push(item);
        }
      }
      else {
        // if false then current item from the selected row collection
        this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == item.Id && x.Type == item.Type), 1);
      }
    });
    this.preserveSelectedRows();
    if (!trueOrfalse) {
      this.selectAll = false;
    }

  }

  preserveSelectedRows() {
    localStorage.setItem("des_myproperties_selectedRows", JSON.stringify(this.selectedRows));
  }

  changeStatus() {

    if (this.statusToChange == Actions.NothingSelected) {
      this.showSelectStatus = true;
    }
    else {
      this.showSelectStatus = false;
      this.loaderService.display(true);
      this.propertyIdList = [];
      this.selectedRows.forEach(item => {
        this.propertyIdList.push(
          {
            PropertyId: item.Id,
            Type: item.Type
          });
      });

      var loggedinUserId = this.user.Id;
      this._propertyListingService.BulkStatusChange(this.statusToChange, this.propertyIdList, loggedinUserId).subscribe(response => {
        if (response) {
          this.resetSelectedRows();
          this.dtElement.dtInstance.then(x => x.draw(false));
          this._toastService.addToast({ title: 'Success', msg: 'Status changed successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
          this.modalRef.hide();
        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to change status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
        this.loaderService.display(false);
      });
    }
  }

  markCompOrArchive() {
    this.loaderService.display(true);
    this.propertyIdList = [];
    this.selectedRows.forEach(item => {
      this.propertyIdList.push(
        {
          PropertyId: item.Id,
          Type: item.Type
        });
    });
    var loggedinUserId = this.user.Id;
    this._propertyListingService.BulkStatusChange(this.compOrArhive, this.propertyIdList, loggedinUserId).subscribe(response => {
      if (response) {
        this.dtElement.dtInstance.then(x => x.draw(false));
        if (this.compOrArhive == CompOrArhive.Comp) {
          this.GetPropertyCount();
          this._toastService.addToast({ title: 'Success', msg: 'Successfully marked as Comp', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        }
        else if (this.compOrArhive == CompOrArhive.Archive) {
          this.GetPropertyCount();
          this._toastService.addToast({ title: 'Success', msg: 'Successfully marked as Archive', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        }
        else if (this.compOrArhive == CompOrArhive.Verify) {
          this._toastService.addToast({ title: 'Success', msg: 'Successfully verified', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        }
        else if (this.compOrArhive == CompOrArhive.LiveListing) {
          this._toastService.addToast({ title: 'Success', msg: 'Successfully moved selected properties into live listings', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        }
        this.resetSelectedRows();
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to perform selected bulk action', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      this.loaderService.display(false);
    });
  }

  reassignSelectedRows() {
    if (this.selectedRows.length == 0 && localStorage.getItem("des_myproperties_selectedRows") !== null) {
      this.selectedRows = JSON.parse(localStorage.getItem("des_myproperties_selectedRows"));
    }
  }

  resetSelectedRows() {
    this.selectedRows = [];
    if (this.propertyList) {
      this.propertyList.forEach(item => {
        item.IsSelected = false;
      });
    }
    this.selectAll = false;
    this.preserveSelectedRows();
  }
  modalRefDuplicates: BsModalRef;
  selectedPropertyIdForDuplicates = 0;
  openModalForDuplicates(template: TemplateRef<any>, classes: any, id) {
    this.selectedPropertyIdForDuplicates = id;
    this.modalRefDuplicates = this.modalService.show(template, { class: classes });
  }

  showPortfolioProperties(id, index) {
    if (this.propertyList[index].PortfolioProperties == undefined || this.propertyList[index].PortfolioProperties.length == 0) {
      this.loaderService.display(true);
      this._propertyListingService.dataEntryStaffPropertyListByPortfolioId(id).subscribe(item => {
        this.propertyList[index].PortfolioProperties = item["data"];
        this.propertyList[index].PortfolioProperties.forEach(p => {
          if (p.CharacteristicsId == 1) {
            p.capRateText = 'ZCF';
          }
          else {
            p.capRateText = String(p.CapRate);
          }
        });

        this.propertyList[index].ShowPortfolioProperties = true;
        this.loaderService.display(false);
      })
    }
    else {
      this.propertyList[index].ShowPortfolioProperties = !this.propertyList[index].ShowPortfolioProperties;
    }
  }
}
